import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'
import { TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { components, services } from '@/utils'

import { billingsOperationsFrequencies } from '@/components/services/tasks/utils'
import sticker from '@/components/sticker'

export default function(h) {
  const frequency = get(this.value, 'data.frequency')
  if (frequency) {
    return h(
      components.menu,
      {
        props: {
          rounded: true,
          placement: 'bottom-start',
          disabled: this.value.state === TaskStates.completed || TaskTypes['payments:recurrent'] === this.value.type,
          offsetDistance: 8,
          sameWidth: true
        }
      },
      [
        h(
          sticker,
          {
            props: {
              value: this.getTranslate(`${services.tasks}.frequencies.${frequency}`),
              label: this.getTranslate(`${services.tasks}.labels.data.frequency`),
              icon: 'repeat',
              color: Colors.grey,
              disabled: this.value.state === TaskStates.completed || TaskTypes['payments:recurrent'] === this.value.type,
              width: '100%',
              to: { service: undefined }
            },
            slot: 'activator'
          }
        ),

        h(
          components.list,
          {
            props: {
              dense: true,
              rounded: true
            }
          },
          billingsOperationsFrequencies.map(frequency => {
            return h(
              components['list-item'],
              {
                props: {
                  label: this.getTranslate(`${services.tasks}.frequencies.${frequency}`),
                  dense: true
                },
                on: {
                  click: () => {
                    this.changeFrequency(this.value.id, frequency)
                  }
                }
              }
            )
          })
        )
      ]
    )
  }
}
